import React, { useMemo } from 'react';

import { UnifiedUserPhoneVerificationContainer } from './UnifiedUserPhoneVerificationContainer';
import { useModalStore } from '../../../stores';
import { EModalContent } from '../../../types';

export const UnifiedUserPhoneVerification = () => {
  const modalStore = useModalStore();

  const isModalOpen = useMemo(
    () =>
      modalStore.lookup()?.name ===
      EModalContent.UNIFIED_USER_PHONE_VERIFICATION,
    [modalStore]
  );

  if (!isModalOpen) {
    return null;
  }

  return <UnifiedUserPhoneVerificationContainer />;
};
